import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants } from 'helpers'


const showRequestLoader  = (text) => reducers.ui.setRequestLoaderVisibility({ show: true, text })

const hideRequestLoader  = () => reducers.ui.setRequestLoaderVisibility({ show: false, text: null })

const setUserLinking     = (isLinking) => reducers.ui.setUserLinking(isLinking)

const getWeather = () => {
  return request.get(constants.smartSarov.weather)
    .then(({ data }) => {
      console.log(data)
      return data
    })
    .then(({ icons, weather }) => {
      reducers.ui.setIcons(icons || [
        'thermometer30.png',
        'thermometer30red.png',
      ])
      reducers.ui.setWeather(weather)
    })
    .catch((error) => console.error(error))
}

const getChat = () => {
  return request.get(constants.smartSarov.chat)
    .then(({ data }) => data)
    .then((chat) => reducers.ui.setChat(chat))
    .catch((error) => console.error(error))
}

const getPressure = () => {
  return request.get(constants.smartSarov.pressure)
    .then(({ data }) => data)
    .then(({ sensor, measures }) => {
      const value = measures && measures[0] && measures[0].value.toFixed(1).replace(/\.0$/, '')

      reducers.ui.setPressure({
        title: sensor.title,
        units: sensor.units,
        value,
        isFetching: Boolean(!sensor.title || !sensor.units || typeof value !== 'string')
      })
    })
    .catch((error) => console.error(error))
}

const getHumidity = () => {
  return request.get(constants.smartSarov.humidity)
    .then(({ data }) => data)
    .then(({ sensor, measures }) => {
      const value = measures && measures[0] && measures[0].value.toFixed(2).replace(/\.00$/, '')

      reducers.ui.setHumidity({
        title: sensor.title,
        units: sensor.units,
        value,
        isFetching: Boolean(!sensor.title || !sensor.units || typeof value !== 'string')
      })
    })
    .catch((error) => console.error(error))
}

const getRadiation = () => {
  return request.get(constants.smartSarov.radiation)
    .then(({ data }) => data)
    .then(({ sensor, measures }) => {
      const value = measures && measures[0] && measures[0].value.toFixed(3).replace(/\.000$/, '')

      reducers.ui.setRadiation({
        title: sensor.title,
        units: sensor.units,
        value,
        isFetching: Boolean(!sensor.title || !sensor.units || typeof value !== 'string')
      })
    })
    .catch((error) => console.error(error))
}

const getWaterLevel = () => {
  return request.get(constants.smartSarov.waterLevel)
    .then(({ data }) => data)
    .then(({ sensor, measures }) => {
      const value = measures && measures[0] && measures[0].value.toFixed(0)

      reducers.ui.setWaterLevel({
        title: sensor.title,
        units: sensor.units,
        value,
        isFetching: Boolean(!sensor.title || !sensor.units || typeof value !== 'string')
      })
    })
    .catch((error) => console.error(error))
}

const getLightning = () => {
  return request.get(constants.smartSarov.lightning)
    .then(({ data }) => data)
    .then(({ sensor, measures }) => {
      const value = measures && measures[0] && measures[0].value.toFixed(0)

      reducers.ui.setLightning({
        title: sensor.title,
        units: sensor.units,
        value,
        isFetching: Boolean(!sensor.title || !sensor.units || typeof value !== 'string')
      })
    })
    .catch((error) => console.error(error))
}

const getWeatherCode = () => {
  return request.get(constants.smartSarov.weatherCode)
    .then(({ data }) => data)
    .then((code) => {
      const script  = code.replace(/.*<script .+ src="/, '').replace(/".+/, '').replace(/\n/, '')
      const html    = code.replace(/<script.*script>/, '')

      reducers.ui.setWeatherCode({ script, html })
    })
    .catch((error) => console.error(error))
}


export default {
  showRequestLoader,
  hideRequestLoader,
  setUserLinking,
  getWeather,
  getChat,
  getPressure,
  getHumidity,
  getRadiation,
  getWaterLevel,
  getLightning,
  getWeatherCode,
}
